<template>
  <v-container class="fill-height d-flex align-center justify-center pa-6">
    <v-card max-width="680" class="pa-6 text-left">
      <v-card-title class="text-h6 ncrm-text-strong">
        {{ $t("auth.noCompany.title") }}
      </v-card-title>
      <v-card-text class="pt-2">
        <v-alert type="error" class="mb-4">
          {{ $t("auth.noCompany.message") }}
        </v-alert>
        <p class="text-body-2 mb-0">
          {{ $t("auth.noCompany.hint") }}
        </p>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn color="primary" @click="logoutAndGoToLogin">
          {{ $t("auth.noCompany.actions.logout") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { clearAuthStorage } from "@/Utile/authStorage.mjs";
import { stopSmartTrackerOnLogout } from "@/Utile/smartTrackerRuntime.mjs";

export default {
  name: "NoCompanyContext",
  methods: {
    // H3: `/logout` (via the smart tracker stop) also expires the httpOnly session cookie, like the main menu logout.
    async logoutAndGoToLogin() {
      await stopSmartTrackerOnLogout();
      clearAuthStorage();
      this.$router.push("/login");
    },
  },
};
</script>
